module.exports = __webpack_public_path__ + "static/img/hct5.616b8bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hct/hct5.jpg
// module id = 9rqz
// module chunks = 0